import colors from 'globals/colors'
import styled from 'styled-components'

export const GraphQLErrorWrapper = styled.div`
  width: 100%;
  line-height: 14px;
  font-size: 12px;
  color: ${colors.reddishPink};
  text-align: left;
  display: flex;
  align-items: center;
  
  & > .anticon {
    font-size: 14px;
    margin-right: 10px;
  }
`
